import { JsonApiRequestError } from '@farfetched/core';
import { Store } from 'effector';
import { createGameRegistryQuery, Game, GameRegistryFilters } from 'shared/api';
import { createRegistryModel, RegistryCallbacks, RegistryModel } from 'shared/lib';

export type CreateGameRegistryModelParams = {
	$accountId?: Store<number | null>;
} & RegistryCallbacks;

export type GameRegistryModel = RegistryModel<Game, GameRegistryFilters, JsonApiRequestError>;

export const createGameRegistryModel = ({
	$accountId,
	...params
}: CreateGameRegistryModelParams): GameRegistryModel => {
	const query = createGameRegistryQuery($accountId);

	const model = createRegistryModel({
		query,
		filters: {
			gameIds: [],
			accountIds: [],
		},
		sortField: 'title',
		...params,
	});

	return model;
};
